module.exports = __webpack_public_path__ + "static/img/img-home_guap.f0efa135.png";